export default __webpack_public_path__ + "static/media/swaggerInterface.46bf99b0.png";